import { Injectable } from '@angular/core';
import { App, Platform, Events } from 'ionic-angular';

import { User }  from '../user/user';
import { Api } from '../api/api';
import { Utils } from '../utils/utils';


/*
*
*  IPTV Provider
*
*/

@Injectable()
export class IPTV {

    // App settings from crm
    public app: any = {};

    // Contract
    public contract: any = {};

    // Encoder
    public encoder : any = {};

    // OLD Encoder (on change)
    public oldEncoder : any = {};

    // Box lists
    public boxs: any = [];

    // Current box
    public box: any = {};

    // Current box ID
    public boxID: any;

    // Current key Box
    public boxKEY: any;

    // Has throughput
    public throughput: boolean = false;

    // streamingPlayer option
    public streamingPlayer: boolean = false;

    // Remote TIME ins MS
    public remote_TMS: number = 500;

    // Remote Timeout
    public remote_TIMEOUT: any = null;

    // Remote Action concatenated
    public remote_ACTION: string = '';
    public remote_ACTION_FULL: string = '';

    // Remote Hook for Number type (ex: BEIN{number})
    public remote_HOOK:string = '{number}';

    // Current resolution
    public resolution: any= {};

    // Current resolution
    public resolutionKEY:string = '';

    // All resolution for this parc
    public resolutions = []; 

    // Cast in action
    public castLoad : boolean = false;

    // Cast current media id
    public castMediaId : number = 0;

    // Latency
    public latency : number = 2000;
    
    // IS Remoting something
    public isRemoting : boolean = false;

    constructor(
        public application: App,
        public events: Events,
        public user: User,
        public api: Api,
        public platform: Platform,
        public utils: Utils
    ) {
        let that = this;
        
        this.events.subscribe('app:reload', (params : any = {}) => { 
            that.init().then(() => {
                that.events.publish('app:refresh');
            }, (err) => {
                that.user.disconnect(true).then( () => {}, (err) => {});
            });
        });

        this.events.subscribe('user:beforeDisconnect', (params : any = {}) => { 
            this.scriptDisconnect();
        });

        this.events.subscribe('user:disconnect', (params : any = {}) => { 
            this.resetData();
        });

        this.events.subscribe('contract:update', (params : any = {}) => {
            this.fetchContract(true);
        });

        this.events.subscribe('sources:update', (params : any = {}) => {
            this.fetchSources(true);
        });

        this.events.subscribe('source:update', (params : any = {}) => {
            this.fetchEncoder(true);
        });

        this.events.subscribe('resolution:update', (params : any = {}) => { 
            this.fetchEncoder(true);
        });

    }

    /*
    *    Getter
    */
    getContract() { return this.contract; }
    getBox() { return this.box; }
    getBoxID() { return this.boxID; }
    getBoxKEY() { return this.boxKEY; }

    /*
    * Reset all property when user disconnect
    */    
    resetData() {
        this.app = {};
        this.contract = {};
        this.encoder = {};
        this.boxs  = [];
        this.box = {};
        this.boxID = 0;
        this.boxKEY = 0;
        this.throughput = false;
        this.streamingPlayer = false;
        this.remote_ACTION = '';
        this.remote_ACTION_FULL = '';
        this.remote_HOOK = '{number}';
        this.resolution = {};
        this.resolutionKEY = '';
        this.castLoad = false;
        this.castMediaId = 0;
    }

    /*
    *     Init   
    */
    init(ts=100) {
        return new Promise((resolve, reject) => {
            this.fetchContract().then(() => {

                this.setContractOptions();

                this.fetchEncoder().then(() => {

                    this.fetchApp();

                    this.setResolutionFromEncoder();

                    this.fetchSources().then(() => {

                        this.setSourceFromEncoder();

                        this.fetchResolutions();

                        resolve();
                        
                    }, (err) => {
                        reject(err);
                    });

                }, (err) => {
                    reject(err);
                });

            }, (err) => {
                 reject(err);
            });
        });
    }

    /*
    *    Fetch global app data
    */
    fetchApp() {
        this.api.getCached('iptv/app').subscribe((response:any)=>{
            this.app = response.result.result;
        });
    }

    /*
    *    Fetch data from API
    */
    fetchContract(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {
            this.api.getCached('iptv/contract', { writeCache:writeCache }).subscribe((response:any)=>{

                if (response.result.error) {
                    reject(response.result.errorMessage);
                } else {
                    this.contract = response.result.result;

                    if (writeCache) {
                        this.setContractOptions();
                        this.events.publish('app:refresh');
                    }
                    resolve();
                }
                
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

    /*
    *    Set attributes from contract parc options
    */
    setContractOptions() {

        this.streamingPlayer = false;

        if (this.contract.parc.has_remote_player == '1') {
            this.streamingPlayer = true;
        }
    }

    /*
    *    Get Encoder
    */
    fetchEncoder(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {

            if (!this.contract || !this.contract.parc || !this.contract.parc.id) {
                reject();
            }

            this.api.getCached('iptv/encoder/'+this.contract.parc.id, { writeCache:writeCache }).subscribe((response:any)=>{

                if (response.result.error) {
                    reject(response.result.errorMessage);
                } else {
                    this.encoder = response.result.result;
                    resolve();
                }
                
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

    /*
    *    Reset global
    */
    reset() {
        this.api.get('iptv/reset', {}, null, 3000).subscribe((response:any)=>{
        }, (err) => {
        });
    }
    
    /*
    *    Reset encoder (if error on change)
    */
    resetEncoder() {

        if (!this.oldEncoder || !this.oldEncoder.id) return false;

        this.api.get('iptv/encoder/'+this.oldEncoder.id+'/reset/'+this.oldEncoder.id_box+'/'+this.oldEncoder.id_resolution).subscribe((response:any)=>{

            this.encoder = this.oldEncoder;
            this.oldEncoder = {};

            this.setSourceFromEncoder();
            this.setResolutionFromEncoder();
            
        },(err) => {
            this.utils.error(this.api.reject(err));
        });
    }

    /*
    *    List sources
    */ 
    fetchSources(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {
            this.api.getCached('iptv/sources/'+this.contract.parc.id, { writeCache:writeCache }).subscribe((response:any)=>{

                if (response.result.error) {
                    reject(response.result.errorMessage);
                } else {
                    this.boxs = response.result.result;

                    if (writeCache) {
                        this.events.publish('app:refresh');
                    }
                    resolve();
                }
                
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }
    
    /*
    *    Set source from IDx
    */ 
    setSource(id)
    {
        // Log
        this.utils.log('IPTV::setSource()');

        // Pause service interval
        this.events.publish('service:pause');

        // Saving if error
        this.oldEncoder = this.encoder;

        return new Promise((resolve, reject) => {
            this.api.get('iptv/encoder/'+this.encoder.id+'/source/'+id).subscribe((response:any)=>{

                this.encoder = response.result.result;

                this.setSourceFromEncoder();

                this.setScriptSource().then(() => {
                    this.utils.log('IPTV::setSource()::OK');
                    this.events.publish('source:update');
                    this.events.publish('service:resume');
                    resolve();
                }, (err) => {
                    this.utils.log('IPTV::setSource()::KO::SCRIPT');
                    this.events.publish('service:resume');
                    this.resetEncoder();
                    reject(this.api.reject(err));
                });
                
            },(err) => {
                this.utils.log('IPTV::setSource()::KO::API');
                this.events.publish('service:resume');
                this.resetEncoder();
                reject(this.api.reject(err));
            });
        });
    }   

    // Set Source in Encoder
    setScriptSource()
    {
        return new Promise((resolve, reject) => {
            this.api.put('iptvscripts/source', this.getParams()).subscribe((response:any)=>{
                resolve();
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }   

    // Fetch all resolutions
    fetchResolutions() {
        this.api.getCached('iptv/resolution/'+this.contract.parc.id).subscribe((response:any)=>{
           this.resolutions = response.result.result;
        },(err) => {
          this.resolutions = [];
        });
    }

    /*
    *    Set resolution from ID
    */ 
    setResolution(id)
    {
        // Log
        this.utils.log('IPTV::setResolution()');

        // Pause service interval
        this.events.publish('service:pause');

        // Saving if error
        this.oldEncoder = this.encoder;
        
        return new Promise((resolve, reject) => {
            this.api.get('iptv/encoder/'+this.encoder.id+'/resolution/'+id).subscribe((response:any)=>{

                let oldResolution = this.resolution.name_tech;

                this.encoder = response.result.result;

                this.setResolutionFromEncoder();

                this.setScriptResolution(oldResolution).then(() => {
                    this.utils.log('IPTV::setResolution()::OK');
                    this.events.publish('resolution:update');
                    this.events.publish('service:resume');
                    resolve();
                }, (err) => {
                    this.utils.log('IPTV::setResolution()::KO::API');
                    this.resetEncoder();
                    this.events.publish('service:resume');
                    reject(this.api.reject(err));
                });

            },(err) => {
                this.utils.log('IPTV::setResolution()::KO::API');
                this.events.publish('service:resume');
                this.resetEncoder();
                reject(this.api.reject(err));
            });
        });
    }

    // Set Resolution in Encoder
    setScriptResolution(oldResolution?:string) {
        return new Promise((resolve, reject) => {
            this.api.put('iptvscripts/resolution', this.getParams({oldResolution:oldResolution})).subscribe((response:any)=>{
                resolve();
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

    // Set Default Volume on Source select
    setDefaultVolume() {
        return new Promise((resolve, reject) => {
            this.api.put('iptvscripts/default/volume', this.getParams()).subscribe((response:any)=>{
                resolve();
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

    // Set Default Channel on Source select
    setDefaultChannel() {
        return new Promise((resolve, reject) => {
            this.api.put('iptvscripts/default/channel', this.getParams()).subscribe((response:any)=>{
                resolve();
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

    // Set Default Channel on Source select
    setConnectionScripts() {
        return new Promise((resolve, reject) => {
            this.api.put('iptvscripts/connect', this.getParams()).subscribe((response:any)=>{
                resolve();
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }


    /*
    *    Set resolution from encoder
    */ 
    setResolutionFromEncoder() {

        if (!this.contract || !this.contract.resolutions) return false;

        // this.resolutionKEY
        for (let item of this.contract.resolutions) {
            if (item.id == this.encoder.id_resolution) {
                this.resolution    = item;
                this.resolutionKEY = item.name;
            }
        }
    }

    /*
    *    Set srouce from encoder
    */ 
    setSourceFromEncoder() {

        var i = 0;
        for (let item of this.boxs) {
            if (item.id == this.encoder.id_box) {
                this.box    = item;
                this.boxID  = this.box.id_box;
                this.boxKEY = i;

                if (this.box.switch_port && this.contract.parc.has_throughput == '1') {
                    this.throughput = true;
                } else {
                    this.throughput = false;
                }
            }
            i++;
        }
    }

    /*
    *    Disconnect user from script
    */
    scriptDisconnect() {

        this.utils.log('IPTV::scriptDisconnect()');

        // Find StreamOff ID 
        let idStreamOff = 0;

        for (let item of this.contract.resolutions) {
            if (item.name_tech == 'Stream_Off') {
                idStreamOff = item.id;
            }
        }

        // Appel reset stream Off
        if (idStreamOff) {
            this.api.get('iptv/encoder/'+this.encoder.id+'/resolution/'+idStreamOff).subscribe((response:any)=>{},(err) => {});
        }
        
        // Appel script 
        this.api.put('iptvscripts/disconnect', this.getParams({boxs:this.boxs})).subscribe((response:any)=>{},(err) => {});
    }

    /*
    *    Cast Method call
    */
    cast(route?:string, url?:string, label?:string, type?:string)
    {
        if (this.isRemoting) return false;

        if (label) this.utils.log('IPTV::cast::'+label);
        else this.utils.log('IPTV::cast::'+route+url);

        this.events.publish('live:loading');
        this.isRemoting = true;

        let params: any = {};

        if (url) {
            params.url = url;
        }
        if (type) {
            params.type = type;
        }

        this.api.put('cast'+route, this.getParams(params)).subscribe((response:any)=>{
            
            if (label) {
                this.setChannelName(label);
            }

            this.events.publish('live:success', label);
            this.isRemoting = false;
        },(err) => {
            this.events.publish('live:error', label);
            this.isRemoting = false;
        });

    }

    /*
    *     Remote buton (here beacause called from channel and remote page)
    */
    remote(input:string, params:any={})
    {
        if (this.remote_TIMEOUT) clearTimeout(this.remote_TIMEOUT);

        if (params.number) {
            this.remote_ACTION = this.remoteNumeric(input);
        } else  {
            this.remote_ACTION = this.remoteString(input, params);
        }

        if (!this.remote_ACTION) return false;
        if (this.isRemoting) return false;

        if (params.label) this.utils.log('IPTV::remote::'+params.label);
        else this.utils.log('IPTV::remote::'+this.remote_ACTION);

        this.events.publish('live:loading');
        
        params.action = this.remote_ACTION;

        this.remote_TIMEOUT = setTimeout( () => {

            this.isRemoting = true;
             
            this.api.put('iptvscripts/remote', this.getParams(params)).subscribe((response:any)=>{

                this.isRemoting = false;

                if (params.number) {
                    this.events.publish('live:success', (this.remote_ACTION_FULL ? this.remote_ACTION_FULL : this.remote_ACTION));
                } else  {
                    this.events.publish('live:success', (params.label ? params.label : input));
                }
            },(err) => {

                this.isRemoting = false;
                
                if (params.number) {
                    this.events.publish('live:error', (this.remote_ACTION_FULL ? this.remote_ACTION_FULL : this.remote_ACTION));
                } else  {
                    this.events.publish('live:error', (params.label ? params.label : input));
                }

                
            });

            this.remote_ACTION = '';
            this.remote_ACTION_FULL = '';

        }, this.remote_TMS);
        
    }

    /*
    *    Remote private method
    */
    remoteNumeric(input) 
    {
        this.setChannelName('');

        if (this.remote_ACTION_FULL.length < 3)
            this.remote_ACTION_FULL = this.remote_ACTION_FULL+input.trim();
        else 
            this.remote_ACTION_FULL = input.trim();

        var hook = this.remote_HOOK;

        return hook.replace('{number}', this.remote_ACTION_FULL);
    }

    /*
    *    Remote private method
    */
    remoteString(input, params?:any)
    {
        this.setChannelName(params.label);

        return this.remote_ACTION += input.trim()+'--';
    }

    /*
    *    Remote private method
    */
    setChannelName(name?:string) 
    {
        if (!name) {
            localStorage.removeItem('lastChannelName--'+this.boxKEY);
            return false;
        }

        localStorage.setItem('lastChannelName--'+this.boxKEY, name.trim());
    }

    /*
    *    Remote private method
    */
    getChannelName() 
    {
        return localStorage.getItem('lastChannelName--'+this.boxKEY);
    }

   /*
    *    Params needed for each iptv request
    */
    getParams(params:any={}) {
        params.user        = this.user.get();
        params.box         = this.box;
        params.boxs        = this.boxs;
        params.encoder     = this.encoder;
        params.parc        = this.contract.parc;
        params.resolution  = this.resolution;

        return params;
    }

}


// WEBPACK FOOTER //
// ./src/providers/iptv/iptv.ts